module.exports = __webpack_public_path__ + "img/radar-logo@2x.ca92ca4f.png";